import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './hero.module.scss'
import Button from '../../../../../components/button'

interface IHeroProps {
  onCtaClick: () => void
}

export default function Hero({ onCtaClick }: IHeroProps) {
  return (
    <div className={styles.outer}>
      <div className={styles.inner}>
        <div className={styles.text}>
          <FormattedMessage
            defaultMessage="Du fokuserar på ditt företag. Vi sköter din bokföring."
            id="landing-pages.signup.hero.heading"
            tagName="h1"
          />
          <p>
            <span>
              <FormattedMessage
                defaultMessage="Vi sköter din bokföring med kärlek. Med Dooer får du full kontroll över ditt företag i vår bokföringstjänst."
                id="landing-pages.signup.hero.lede"
              />
            </span>
          </p>
          <Button onClick={onCtaClick} variant="success">
            <FormattedMessage defaultMessage="Få ditt pris" id="landing-pages.signup.hero.cta" />
          </Button>
        </div>
      </div>
    </div>
  )
}
